<template>
  <div class="container-fluid border-top">
    <div class="container py-3 mt-2 text-left">
            <span class="lead font-weight-bold">
                Vessel Overview
            </span>
      <span class="float-right text-small">
                <button class="btn btn-dark btn-sm ml-3" @click="goBack">GO BACK</button>
            </span>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <nav class="bg-light">
            <div class="nav nav-tabs nav-fill w-100" id="nav-tab" role="tablist">
              <li class="nav-item">
                <router-link
                    :to="{name: 'VesselGeneralInfo' }"
                    tag="a"
                    class="nav-link border border-bottom-0"
                    :class="{'active': isActiveRoute('VesselGeneralInfo')}"
                    role="tab"
                    data-toggle="list"
                >
                  General Info
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{name: 'VesselSpecification' }"
                             tag="a"
                             class="nav-link border border-bottom-0"
                             :class="{'active': isActiveRoute('VesselSpecification')}"
                             role="tab"
                             data-toggle="list"
                > Specification
                </router-link>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link border border-bottom-0 disabled">Communication</a>
                <!-- <router-link :to="{name: 'VesselCommunication' }"
                           tag="a"
                           class="nav-link border border-bottom-0"
                           :class="{'active': isActiveRoute('VesselCommunication')}"
                           role="tab"
                           data-toggle="list"
              > Communication </router-link> -->
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link border border-bottom-0 disabled">Documents</a>

                <!-- <router-link :to="{name: 'VesselDocument' }"
                tag="a"
                class="nav-link border border-bottom-0"
                :class="{'active': isActiveRoute('VesselDocument')}"
                role="tab"
                data-toggle="list"
   > Documents </router-link> -->
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link border border-bottom-0 disabled">Crew List </a>
                <!-- <router-link :to="{name: 'VesselCrewList' }"
                             tag="a"
                             class="nav-link border border-bottom-0"
                             :class="{'active': isActiveRoute('VesselCrewList')}"
                             role="tab"
                             data-toggle="list"
                > Crew List </router-link> -->
              </li>
              <!--                            <li class="nav-item">-->
              <!--                                <router-link :to="{name: 'VesselSpecification' }"-->
              <!--                                             tag="a"-->
              <!--                                             class="nav-link border border-bottom-0"-->
              <!--                                             :class="{'active': isActiveRoute('VesselSpecification')}"-->
              <!--                                             role="tab"-->
              <!--                                             data-toggle="list"-->
              <!--                                >-->
              <!--                                    Specification-->
              <!--                                </router-link>-->
              <!--                            </li>-->
              <!--                            <li class="nav-item">-->
              <!--                                <router-link :to="{name: 'VesselCommunication' }"-->
              <!--                                             tag="a"-->
              <!--                                             class="nav-link border border-bottom-0"-->
              <!--                                             :class="{'active': isActiveRoute('VesselCommunication')}"-->
              <!--                                             role="tab"-->
              <!--                                             data-toggle="list"-->
              <!--                                >-->
              <!--                                    Communication-->
              <!--                                </router-link>-->
              <!--                            </li>-->
              <!--                            <li class="nav-item">-->
              <!--                                <router-link :to="{name: 'VesselDocument' }"-->
              <!--                                             tag="a"-->
              <!--                                             class="nav-link border border-bottom-0"-->
              <!--                                             :class="{'active': isActiveRoute('VesselDocument')}"-->
              <!--                                             role="tab"-->
              <!--                                             data-toggle="list"-->
              <!--                                >-->
              <!--                                    Documents-->
              <!--                                </router-link>-->
              <!--                            </li>-->
              <!--                            <li class="nav-item">-->
              <!--                                <router-link :to="{name: 'VesselCrewList' }"-->
              <!--                                             tag="a"-->
              <!--                                             class="nav-link border border-bottom-0"-->
              <!--                                             :class="{'active': isActiveRoute('VesselCrewList')}"-->
              <!--                                             role="tab"-->
              <!--                                             data-toggle="list"-->
              <!--                                >-->
              <!--                                    Crew List-->
              <!--                                </router-link>-->
              <!--                            </li>-->


              <!--                            <li class="nav-item">-->
              <!--                                <router-link :to="{name: 'FlagHistoryIndex' }"-->
              <!--                                             tag="a"-->
              <!--                                             class="nav-link border border-bottom-0"-->
              <!--                                             :class="{'active': isActiveRoute('FlagHistoryIndex')}"-->
              <!--                                             role="tab"-->
              <!--                                             data-toggle="list"-->
              <!--                                > Vessel History </router-link>-->
              <!--                            </li>-->

              <li class="nav-item">
                <router-link :to="{name: 'FlagHistoryIndex' }"
                             tag="a"
                             class="nav-link border border-bottom-0"
                             :class="{'active': isActiveRoute('FlagHistoryIndex')}"
                             role="tab"
                             data-toggle="list"
                > Vessel History
                </router-link>
              </li>

            </div>
          </nav>

          <div class="p-3 text-left border border-top-0">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {vueAppMixin} from '@/mixins/vueAppMixin';

export default {
  name: 'VesselShow',
  mixins: [vueAppMixin],

};
</script>

<style scoped>
#documentsTable td:nth-child(2) {
  text-align: left;
}

</style>
